import React from 'react';
import { Box, Grid, Typography, Divider, Paper } from '@mui/material';

const colors = {
  'Paper & Background': {
    Paper: '#fcfcfc',
    SecondaryPaper: '#F8F8FF',
    DarkPaper: '#111936',
    DarkBackground: '#1a223f',
    DarkLevel1: '#29314f',
    DarkLevel2: '#212946'
  },
  Text: {
    'Dark Text Title': '#d7dcec',
    'Dark Text Primary': '#bdc8f0',
    'Dark Text Secondary': '#8492c4'
  },
  Primary: {
    'Primary Light': '#efe7ff',
    'Primary 200': '#b89bfe',
    'Primary Main': '#5c26fd',
    'Primary Dark': '#4d21f7',
    'Primary 800': '#0010e9',
    'Dark Primary Light': '#eef2f6',
    'Dark Primary Main': '#2196f3',
    'Dark Primary Dark': '#1e88e5',
    'Dark Primary 200': '#90caf9',
    'Dark Primary 800': '#1565c0'
  },
  Secondary: {
    'Secondary Light': '#e0f7fa',
    'Secondary 200': '#80deea',
    'Secondary Main': '#00bbd4',
    'Secondary Dark': '#00abc1',
    'Secondary 800': '#00828f',
    'Dark Secondary Light': '#d1c4e9',
    'Dark Secondary 200': '#b39ddb',
    'Dark Secondary Main': '#7c4dff',
    'Dark Secondary Dark': '#651fff',
    'Dark Secondary 800': '#6200ea'
  },
  Tertiary: {
    'Tertiary Light': '#ffe082',
    'Tertiary Main': '#ffc107',
    'Tertiary Dark': '#ffa000'
  },
  Success: {
    'Success Light': '#e8f5e9',
    'Success 200': '#a5d6a7',
    'Success Main': '#4caf50',
    'Success Dark': '#43a047'
  },
  Error: {
    'Error Light': '#ffab91',
    'Error Main': '#ff5722',
    'Error Dark': '#e64a19'
  },
  Info: {
    'Info Light': '#40c4ff',
    'Info Main': '#00b0ff',
    'Info Dark': '#0091ea'
  },
  Warning: {
    'Warning Light': '#ffcc80',
    'Warning Main': '#ff9800',
    'Warning Dark': '#f57c00'
  },
  Green: {
    'Green Light': '#64ffda',
    'Green Main': '#1de9b6',
    'Green Dark': '#00bfa5'
  },
  Orange: {
    'Orange Light': '#fbe9e7',
    'Orange Main': '#ffab91',
    'Orange Dark': '#d84315'
  },
  Grey: {
    'Grey 50': '#f8fafc',
    'Grey 100': '#eef2f6',
    'Grey 200': '#e3e8ef',
    'Grey 300': '#cdd5df',
    'Grey 500': '#697586',
    'Grey 600': '#4b5565',
    'Grey 700': '#364152',
    'Grey 900': '#121926'
  },
  Skill: {
    'Skill 10': '#fff3e0',
    'Skill 20': '#e0f2f1',
    'Skill 30': '#b2dfdb',
    'Skill 40': '#80cbc4',
    'Skill 50': '#4db6ac'
  },
  Blue: {
    'Blue Light': '#E3F2FD',
    'Blue 200': '#90CAF9',
    'Blue Main': '#2196F3',
    'Blue 800': '#1565C0',
    'Blue Dark': '#0D47A1'
  },
  Red: {
    'Red Light': '#FFEBEE',
    'Red 200': '#EF9A9A',
    'Red Main': '#F44336',
    'Red 800': '#C62828',
    'Red Dark': '#B71C1C'
  }
};

const ColorBox = ({ name, hex }) => {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Paper variant="outlined" sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: 1,
            bgcolor: hex,
            border: '1px solid #ccc',
            mr: 2
          }}
        />
        <Box>
          <Typography variant="body1" fontWeight="bold">
            {name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {hex}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );
};

const ColorPaletteViewer = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Complete Color Palette Viewer
      </Typography>
      {Object.entries(colors).map(([groupName, colorSet]) => (
        <Box key={groupName} sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            {groupName}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            {Object.entries(colorSet).map(([name, hex]) => (
              <ColorBox key={name} name={name} hex={hex} />
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default ColorPaletteViewer;
